//权限管理

import router from '../router'
import store from '../store'
import {
    getToken
} from './auth'

//不需要token的路由
const notNeedLoginList = ['/login','/authRedirect']


async function getWhiteList() {
    //访问白名单 
    window.__white_list = []
    try {

    } catch (error) {
        console.error(error)
    }
    return window.__white_list
}


/**
 * 路由拦截
 */
router.beforeEach((to, from, next) => {
    console.log(!notNeedLoginList.includes(to.path))
    //需要登录权限
    if (!notNeedLoginList.includes(to.path)) {
        //判断是否登录 
        if (hasLogin()) {
            if (['/about'].includes(to.path)) {
                next()
            } else {
                next('/login')
            }
            next()
        } else {
            if (to.path === '/login') {
                next()
            } else {
                next('/login')
            }
        }
    } else {
        next()
    }
})



// 判断用户是否登录
const hasLogin = () => {
    return getToken();
};